import { AsyncStoreItem } from '@lib/store';
import { GetDocumentListEmdResponse } from 'src/sdk-servicing';

/**
 * GetDocumentListEmd model
 */
export interface GetDocumentListEmdModel {
  model: GetDocumentListEmdResponse | null;
}

/**
 * GetDocumentListEmdResponse model details
 */
export interface GetDocumentListEmdStateDetails extends AsyncStoreItem {}

/**
 * GetDocumentListEmd store state
 */
export interface GetDocumentListEmdState extends GetDocumentListEmdStateDetails, GetDocumentListEmdModel {}

/**
 * Name of the GetDocumentListEmd Store
 */
export const GET_DOCUMENT_LIST_EMD_STORE_NAME = 'getDocumentListEmd';

/**
 * GetDocumentListEmd Store Interface
 */
export interface GetDocumentListEmdStore {
  /** GetDocumentListEmd state */
  [GET_DOCUMENT_LIST_EMD_STORE_NAME]: GetDocumentListEmdState;
}
